module.exports = _.flatMap;